export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13775.fc29284e.jpg";